/**
 * Potencia item
 * @param {*} editor
 */
function square(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `\\sqrt{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Raiz',
    action: square,
    className: 'qsrtrooticon',
    title: 'Raiz',
  };

  return option;
}
